
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "SortColumn"
})
export default class SortColumn extends Vue {
  @Prop(Function) readonly onSortChange!: Function;
  @Prop(String) readonly column!: String;
  @Prop(String) readonly label!: String;
  @Prop(String) readonly smallerText!: String;
  @Prop(Object) readonly active!: Record<string, string>;
  @Prop(String) readonly initialDir: String;

  currentSort: any = {
    col: "",
    dir: "asc"
  };

  mounted() {
    this.currentSort.col = this.column;

    if(this.initialDir) {
      this.currentSort.dir = this.initialDir;
    }
  }

  changeSort() {
    this.currentSort.dir = this.currentSort.dir === "asc" ? "desc" : "asc";
    this.onSortChange(this.currentSort);
  }
}
